module.exports = __webpack_public_path__ + "b7a88a213741f09b675bb5987c0badb6.svg";